import React from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import NotFound from "components/NotFound";
import List from "./List";
import Review from "./Review";
import Offline from "./Offline";
import InvoiceList from "./InvoiceList";
import "./Purchase.less";

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({});

class Producer extends React.Component {
    render() {
        const { match } = this.props;
        const basepath = match.path === "/" ? "" : match.path;

        return (
            <Switch>
                <Route exact path={`${basepath}/offline`} component={Offline} />
                <Route exact path={`${basepath}/list`} component={List} />
                <Route exact path={`${basepath}/invoice`} component={InvoiceList} />
                <Route exact path={`${basepath}/review`} component={Review} />
                <Route exact component={NotFound} />
            </Switch>
        );
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Producer);
